import { FirstDepositToWallet } from 'src/types/res-dto/first_deposit_to_wallet';
import { IUserBalance, LoginHistory } from 'src/types/store-types';
import { APP_API_VERSION, LEGITIMUZ_TOKEN } from 'src/utils/constants';
import HttpClient from './http';
import { withTurnstileToken } from './turnstileService';

const balanceRequest = (): Promise<IUserBalance> => {
  return HttpClient.get({
    path: `${APP_API_VERSION}/getBalance`,
    baseURL: process.env.REACT_APP_REMOTE as string,
  });
};

const firstDepositToBonusRequest = (params: any): Promise<FirstDepositToWallet> => {
  return HttpClient.post(
    {
      path: `${APP_API_VERSION}/firstDepositToBonusWallet`,
      baseURL: process.env.REACT_APP_REMOTE as string,
    },
    params
  );
};

const loginHistoryRequest = (params: Record<string, any>): Promise<LoginHistory> => {
  return HttpClient.get(
    { path: `${APP_API_VERSION}/getLoginHistory`, baseURL: process.env.REACT_APP_REMOTE as string },
    true,
    params
  );
};

const closeAccountRequest = (params: Record<string, any>): Promise<any> => {
  return HttpClient.post(
    { path: `${APP_API_VERSION}/closeAccount`, baseURL: process.env.REACT_APP_REMOTE as string },
    params
  );
};

const inactivityForceLogOutRequest = (params: Record<string, any>): Promise<any> => {
  return HttpClient.post(
    { path: `${APP_API_VERSION}/logout`, baseURL: process.env.REACT_APP_REMOTE as string },
    params
  );
};

const verifyEmail = (payload: { key: string }): Promise<any> => {
  return HttpClient.post(
    { path: `${APP_API_VERSION}/confirmEmail`, baseURL: process.env.REACT_APP_REMOTE as string },
    payload,
    false
  );
};

const transactionRequest = (params: any, subSection: string): Promise<any> => {
  if (subSection === 'casino_history') {
    params.groupByGame = true;
  }

  return HttpClient.get(
    { path: `${APP_API_VERSION}/bc/getMovements`, baseURL: process.env.REACT_APP_REMOTE as string },
    true,
    params
  );
};

const getPendingTransaxtions = (): Promise<any> => {
  return HttpClient.get(
    {
      path: `/payments/getRequesterPendingTransactionRequests`,
      baseURL: process.env.REACT_APP_PAYMENT_REMOTE as string,
    },
    true,
    { movementType: 'withdraw' }
  );
};

const cancelPendingTransaction = (transactionId: string): Promise<any> => {
  return HttpClient.patch(
    {
      path: `/payments/cancelTransactionRequest`,
      baseURL: process.env.REACT_APP_PAYMENT_REMOTE as string,
    },
    { transactionId },
    undefined,
    undefined,
    true
  );
};

const changePasswordRequest = (params: Record<string, any>): Promise<any> => {
  return HttpClient.post(
    { path: `${APP_API_VERSION}/bc/changePassword`, baseURL: process.env.REACT_APP_REMOTE as string },
    params
  );
};

const checkOldPasswordRequest = async (params: Record<string, any>): Promise<any> => {
  return HttpClient.post(
    { path: `${APP_API_VERSION}/authenticatePlayer`, baseURL: process.env.REACT_APP_REMOTE as string },
    { ...params, ...(await withTurnstileToken()) }
  );
};

const paymentMethodsIframeRequest = (params: any): Promise<PaymentMethod[]> => {
  return HttpClient.get(
    {
      path: `/payments/getAccountPaymentMethods`,
      baseURL: process.env.REACT_APP_PAYMENT_REMOTE as string,
    },
    true,
    params
  );
};

const getIframeURLRequest = (params: any): Promise<any> => {
  return HttpClient.get(
    {
      path: `/payments/getIframeURL`,
      baseURL: process.env.REACT_APP_PAYMENT_REMOTE as string,
    },
    true,
    params
  );
};

const bankRequest = (url: string, methodId: string): Promise<any> => {
  return HttpClient.get(
    {
      path: url,
      baseURL: process.env.REACT_APP_PAYMENT_REMOTE as string,
    },
    true,
    { methodId: methodId }
  );
};

const newPaymentTransactionRequest = (data: { transactionType: string }): Promise<any> => {
  const config = data.transactionType?.toLowerCase() === 'deposit' ? { withCredentials: true } : undefined;

  return HttpClient.post(
    {
      path: `/payments/${data.transactionType.toLowerCase()}`,
      baseURL: process.env.REACT_APP_PAYMENT_REMOTE as string,
    },
    data,
    true,
    undefined,
    config
  );
};

const initSdkLegitimuzRequest = (data: {
  meta: { cpf: string };
  deviceinfo: string;
  hardware_concurrency: number;
}): Promise<any> => {
  const action = 'signin';
  const betsafeAction = 'signin';

  if (!LEGITIMUZ_TOKEN) {
    return Promise.resolve(null);
  }

  return HttpClient.post(
    {
      path: `/external/fraud-prevention/analysis?token=${LEGITIMUZ_TOKEN}&action=${action}&betsafe_action=${betsafeAction}`,
      baseURL: 'https://api.legitimuz.com',
    },
    data
  );
};

const getBankListRequest = (payment: any): Promise<any> => {
  return HttpClient.get(
    { path: `/${payment.method}/getBankList`, baseURL: process.env.REACT_APP_REMOTE as string },
    true,
    {
      methodId: payment.methodId,
    }
  );
};

export {
  balanceRequest,
  bankRequest,
  cancelPendingTransaction,
  changePasswordRequest,
  checkOldPasswordRequest,
  closeAccountRequest,
  firstDepositToBonusRequest,
  getBankListRequest,
  getIframeURLRequest,
  getPendingTransaxtions,
  inactivityForceLogOutRequest,
  initSdkLegitimuzRequest,
  loginHistoryRequest,
  newPaymentTransactionRequest,
  paymentMethodsIframeRequest,
  transactionRequest,
  verifyEmail,
};
